export default __webpack_public_path__ + "a7241b2363a716e9245fe6f97027f65b.jpg";